import api from './api';
import {AppResponse} from "../models/common/app-response";

class UsersService {

  baseUrl: string = "/api/v1/users";

    toggleDismissal(id: number, isDismissed: boolean) {
        return api.patch<AppResponse<number>>(`${this.baseUrl}/${id}/dismiss?isDismissed=${isDismissed}`);
    }

    unlinkEsia(id: number) {
        return api.patch<AppResponse<number>>(`${this.baseUrl}/${id}/unlink-esia`);
    }
}

export const usersService = new UsersService();